import { render, staticRenderFns } from "./image_lightbox.vue.js?vue&type=template&id=da7c31b4!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./image_lightbox.vue?vue&type=template&id=da7c31b4"
import script from "./image_lightbox.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./image_lightbox.vue?vue&type=script&lang=js"
export * from "./image_lightbox.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./image_lightbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da7c31b4')) {
      api.createRecord('da7c31b4', component.options)
    } else {
      api.reload('da7c31b4', component.options)
    }
    module.hot.accept("./image_lightbox.vue.js?vue&type=template&id=da7c31b4!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./image_lightbox.vue?vue&type=template&id=da7c31b4", function () {
      api.rerender('da7c31b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "behaviors/components/image_lightbox.vue"
export default component.exports